module.exports = __webpack_public_path__ + "img/seabourn.bf04c358.jpg";